import {isEmpty} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';

import styles from './ModifiedAsterisk.less';

const ModifiedAsterisk = ({isModified, text}) => {
  const DivOrSpan = isEmpty(text) ? 'span' : 'div';
  return isModified ? (
    <DivOrSpan className={styles.dlModifiedAsterisk}>
      <span className={styles.dlModifiedAsteriskAsterisk}>{'*'}</span>
      {!isEmpty(text) ? <span>{text}</span> : null}
    </DivOrSpan>
  ) : null;
};

ModifiedAsterisk.displayName = 'ModifiedAsterisk';

ModifiedAsterisk.propTypes = {
  isModified: PropTypes.bool,
  text: PropTypes.string,
};

ModifiedAsterisk.defaultProps = {
  isModified: false,
  text: '',
};

export default ModifiedAsterisk;
